import React from 'react';
import { Lock } from 'lucide-react';
export function AccessRestricted() {
  return <div className="flex items-center justify-center min-h-[400px]" data-id="element-1">
      <div className="text-center max-w-md" data-id="element-2">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-100 rounded-full mb-4" data-id="element-3">
          <Lock className="w-8 h-8 text-slate-400" data-id="element-4" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-5">
          Access Restricted
        </h2>
        <p className="text-slate-600" data-id="element-6">
          You don't have permission to view the Commission Center.
          <br data-id="element-7" />
          If you believe you should have access, please contact your Salesforce
          administrator.
        </p>
      </div>
    </div>;
}